var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchNoResultLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 100,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#search-no-result-lock_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 79.5,
  cy: 49.5,
  r: 44.5,
  fill: "#FFFBF3"
}), /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 61,
  x: 21.5,
  y: 22.5,
  fill: "#fff",
  fillOpacity: 0.3,
  rx: 1.857
}), /*#__PURE__*/React.createElement("rect", {
  width: 118,
  height: 61,
  x: 21.5,
  y: 22.5,
  stroke: "#F0F0F0",
  rx: 1.857
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB5",
  d: "M116.822 45.822a6.1 6.1 0 0 0 6.107-6.108 6.103 6.103 0 0 0 6.108 6.108 6.103 6.103 0 0 0-6.108 6.107c0-3.36-2.746-6.108-6.107-6.108"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M101.607 73.292c-.001.339-.11.67-.312.95-.203.281-.49.5-.826.629a1.96 1.96 0 0 1-1.06.096 1.9 1.9 0 0 1-.939-.47l-9.904-9.202 2.427-2.426 10.077 9.202c.173.16.309.35.402.56.092.21.138.435.135.661"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006E52",
  d: "m90.428 59.836 3.022 3.022a.92.92 0 0 1 0 1.304l-3.288 3.288a.92.92 0 0 1-1.305 0l-3.021-3.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M79.164 68.328c8.375 0 15.164-6.79 15.164-15.164 0-8.375-6.79-15.164-15.164-15.164C70.789 38 64 44.79 64 53.164c0 8.375 6.79 15.164 15.164 15.164"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFBF3",
  d: "M79.165 66.508c7.37 0 13.344-5.974 13.344-13.344S86.534 39.82 79.165 39.82c-7.37 0-13.345 5.974-13.345 13.344s5.975 13.344 13.345 13.344"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M78.262 55.343a4.17 4.17 0 0 1 2.31-3.652 2.31 2.31 0 0 0 1.156-2.45 2.32 2.32 0 0 0-4.622.428 1.156 1.156 0 0 1-2.31 0 4.621 4.621 0 0 1 9.174-.831 4.62 4.62 0 0 1-2.311 4.887 1.9 1.9 0 0 0-1.075 1.618 1.161 1.161 0 1 1-2.322 0M79.41 61.224a1.156 1.156 0 1 1 0-2.313 1.156 1.156 0 0 1 0 2.313"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#search-no-result-lock_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 14,
  x: 31,
  y: 15,
  fill: "#fff",
  rx: 1.895
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#search-no-result-lock_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  d: "M117 17.21c0-1.22.99-2.21 2.211-2.21h9.578A2.21 2.21 0 0 1 131 17.21v9.58c0 1.22-.99 2.21-2.211 2.21h-9.578A2.21 2.21 0 0 1 117 26.79z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillRule: "evenodd",
  clipPath: "url(#search-no-result-lock_svg__d)",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M123.977 20.46a1.52 1.52 0 0 0-1.533 1.51 1.52 1.52 0 0 0 1.533 1.508c.846 0 1.533-.676 1.533-1.509s-.687-1.508-1.533-1.508m-2.733 1.51c0-1.486 1.224-2.69 2.733-2.69s2.732 1.204 2.732 2.69c0 1.484-1.223 2.688-2.732 2.688s-2.733-1.204-2.733-2.689"
}), /*#__PURE__*/React.createElement("path", {
  d: "M125.058 23.034a.61.61 0 0 1 .849 0l1.159 1.142a.58.58 0 0 1 0 .834.606.606 0 0 1-.848 0l-1.16-1.141a.584.584 0 0 1 0-.835"
})), /*#__PURE__*/React.createElement("rect", {
  width: 75,
  height: 4,
  x: 37,
  y: 20,
  fill: "#F0F0F0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FB5",
  d: "M32 65c5.278 0 9.5-4.048 9.5-9 0 5 4.273 9 9.5 9-5.278 0-9.5 4.048-9.5 9 0-4.952-4.273-9-9.5-9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "search-no-result-lock_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h160v100H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "search-no-result-lock_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M121.043 19.084h6.398v6.297h-6.398z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "search-no-result-lock_svg__b",
  width: 114.152,
  height: 28.152,
  x: 23.924,
  y: 10.754,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.83
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.538
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.364706 0 0 0 0 0.368627 0 0 0 0 0.384314 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_21306_52469"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_21306_52469",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "search-no-result-lock_svg__c",
  width: 86.079,
  height: 86.079,
  x: 80.961,
  y: -14.345,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 6.695
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 18.02
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.191667 0 0 0 0 0.158809 0 0 0 0 0.134167 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_21306_52469"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_21306_52469",
  result: "shape"
})))));
export { SvgSearchNoResultLock as ReactComponent };
export default __webpack_public_path__ + "static/media/search-no-result-lock.0ebca671.svg";